import React from "react";
import {
  Button,
  Col,
  Container,
  FormControl,
  FormLabel,
  Row,
} from "react-bootstrap";
import {
  FabricStyleSearchCriteria,
  PageListBean,
  PurchaseOrderSearchCriteria,
  RestFabricStyleListBeanRequest,
  RestPageListBean,
  RestPurchaseOrderListRequest,
  RestReadRequest,
  RestVendorListRequest,
  VendorSearchCriteria,
} from "../ds/ds.js";
import { LookupHandler, LookupResultDetails } from "../ds/lookup_ds.js";
import { AppContext } from "../AppContext.js";
import { Eraser, TickIcon } from "../gui_components/Icons.js";
import {
  DatePickerComponent,
  InputTextbox,
  ShowError,
  ProgressBar,
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
} from "../gui_components/Util.js";
import { FabricStyleLookupHandler } from "../lookup/FabricStyleLookupHandler.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import { VendorLookupHandler } from "../lookup/VendorLookupHandler.js";
import { ModuleUtils } from "../modules/ModuleUtils.js";
import { FabricStyleService } from "../services/FabricStyleService.js";
import { PurchaseOrderService } from "../services/PurchaseOrderService.js";
import { VendorService } from "../services/VendorService.js";
import { ConfigManager } from "../config/ConfigManager.js";
export class PurchaseOrderLookupHandler extends LookupHandler {
  static contextType = AppContext;
  constructor(companyCode, attribute_name, vendorCode, status) {
    super();
    this.attribute_name = attribute_name;
    this.lookupTitle = attribute_name + " Lookup";
    this.companyCode = companyCode;
    this.vendorCode = vendorCode;
    this.status = status;
    let resetCriteria = new PurchaseOrderSearchCriteria();
    resetCriteria.companyCode = companyCode;
    this.resetCriteria = resetCriteria;
    let purchaseOrderLookupCriteria = new PurchaseOrderSearchCriteria();
    purchaseOrderLookupCriteria.companyCode = this.companyCode;
    purchaseOrderLookupCriteria.vendorCode = this.vendorCode;
    purchaseOrderLookupCriteria.orderStatus = this.status;
    let newCriteria = new PurchaseOrderSearchCriteria();
    newCriteria.companyCode = companyCode;
    this.newCriteria = newCriteria;
    let lookupCriteriaView = PurchaseOrderLookupCriteraHandler(
      companyCode,
      purchaseOrderLookupCriteria
    );
    let lookupDataCallback = function (
      lookup_dialog,
      page_number,
      searchCriteria,
      filterText
    ) {
      this.fetchDataFromService(
        lookup_dialog,
        page_number,
        searchCriteria,
        filterText
      );
    };
    this.setDetails(
      lookupDataCallback,
      purchaseOrderLookupCriteria,
      lookupCriteriaView
    );
    ModuleUtils.getPurchaseOrderStatusList();
    this.initColumns();
  }
  initColumns() {
    const is3PL = ConfigManager.isPurchaseBasedOnCustomerFlag() ? true : false;
    this.addColumnDefinition(this.attribute_name, "code", 0, true); //1
    this.addColumnDefinition(" Vendor", "vendorCode", 0, false); //1
    this.addColumnDefinition(" VendorName", "vendorName", 0, false); //1
    this.addColumnDefinition(
      !is3PL ? "FabricStyles" : "Items",
      "fabricStyleCode",
      0,
      false
    ); //1
    this.addColumnDefinition(" PurchaseDate", "orderDate", 0, false); //1
    this.addColumnDefinition("Status", "orderStatus", 0, false); //3

    this.addColumnDefinition(" BuyingTerms", "buyingTermsCode", 0, false); //1
    this.addColumnDefinition("GrandTotalAmt", "grandTotalAmount", 0, false); //3
  }
  loadPurchaseOrderList = (lookup_dialog, pageNumber, searchCriteria) => {
    let po_criteria = new PurchaseOrderSearchCriteria(); //To be fetched from CriteriaHandler
    po_criteria.companyCode = this.companyCode;
    if (searchCriteria !== undefined && searchCriteria !== null) {
      po_criteria.purchaseOrderNumberStartsWith =
        searchCriteria.purchaseOrderNumberStartsWith;
      po_criteria.purchaseOrderNumberContains =
        searchCriteria.purchaseOrderNumberContains;
      if (isEmptyString(this.vendorCode)) {
        po_criteria.vendorCode = searchCriteria.vendorCode;
      } else {
        po_criteria.vendorCode = this.vendorCode;
      }
      po_criteria.createdDate = searchCriteria.createdDate;
      po_criteria.orderStartDate = searchCriteria.orderStartDate;
      po_criteria.orderStopDate = searchCriteria.orderStopDate;
      po_criteria.orderStopDateFrom = searchCriteria.orderStopDateFrom;
      po_criteria.orderStopDateTo = searchCriteria.orderStopDateTo;
      if (isEmptyString(this.status)) {
        po_criteria.orderStatus = searchCriteria.orderStatus;
      } else {
        po_criteria.orderStatus = this.status;
      }
      po_criteria.incoterm = searchCriteria.incoterm;
      po_criteria.fabricStyleCode = searchCriteria.fabricStyleCode;
      po_criteria.fabricStyleColorCode = searchCriteria.fabricStyleColorCode;
    }
    let po_pageList = new PageListBean();
    po_pageList.pageSize = 50; //TODO --> Fetch from Config
    po_pageList.pageNumber = pageNumber;
    po_pageList.currentPage = pageNumber;
    let po_requestInput = new RestPurchaseOrderListRequest();
    po_requestInput.pageInput = po_pageList;
    po_requestInput.searchCriteria = po_criteria;
    PurchaseOrderService.getPurchaseOrderPageList(
      po_requestInput,
      (response) => this.loadPurchaseOrderListResponse(response, lookup_dialog),
      this.loadPurchaseOrderListError
    );
  };
  loadPurchaseOrderListResponse = (response, lookup_dialog) => {
    let poList = [];
    let totalCount = 0;
    let currentPageNumber = 0;
    let pageSize = 0;
    if (
      response.data.purchaseOrderPageList != null &&
      response.data.purchaseOrderPageList.purchaseOrders !== null
    ) {
      poList = response.data.purchaseOrderPageList.purchaseOrders;
      totalCount = response.data.purchaseOrderPageList.totalCount;
      currentPageNumber = response.data.purchaseOrderPageList.currentPage;
      pageSize = response.data.purchaseOrderPageList.pageSize;
      poList.map((pl) => {
        pl.orderStatus = ModuleUtils.getPurchaseOrderStatusCaption(
          pl.orderStatus
        );
      });
    }
    let lookup_result_details = new LookupResultDetails();
    lookup_result_details.pageData = poList;
    let total_count = 0;
    if (this.lookup_data != null) {
      total_count = this.lookup_data.length;
    }
    lookup_result_details.totalRecordsCount = totalCount;
    lookup_result_details.currentPageNumber = currentPageNumber;
    lookup_result_details.pageSize = pageSize;
    lookup_result_details.criteriaDisplayString = ""; //TODO
    lookup_dialog.updateResultCallBack(lookup_result_details);
  };
  loadPurchaseOrderListError = (error) => {
    ShowError("Error : " + error);
  };
  fetchDataFromService(lookup_dialog, pageNumber, searchCriteria, filterText) {
    let search = { ...searchCriteria };
    if (search != null && search != "unDefined") {
      // if (isEmptyString(search.purchaseOrderNumberContains)) {
      if (!isEmptyString(filterText)) {
        search.purchaseOrderNumberContains = filterText;
        this.searchCriteria = new PurchaseOrderSearchCriteria();
      }
    }
    if (lookup_dialog != null) {
      this.loadPurchaseOrderList(lookup_dialog, pageNumber, search);
    }
  }
}
const PurchaseOrderLookupCriteraHandler = (
  companyCode,
  purchaseOrderLookupCriteria
) => {
  return class extends React.Component {
    static contextType = AppContext;
    constructor(props) {
      super(props);
      this.state = {
        searchCriteria: new PurchaseOrderSearchCriteria(),
        incoTerms: [],
        showAutoCompleteincoTermsList: true,
        incoTermsPageListForAutoCompleteList: new Array(),

        showAutoCompleteVendorList: true,
        vendorPageListForAutoCompleteList: new Array(),

        fabricPageListForAutoCompleteList: true,
        fabricPageListForAutoCompleteList: new Array(),
        isShowColorLookup: false,
        colorLookupHandler: null,
        is3PL: false,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      };
      this.criteriaLookupHandler = React.createRef();
      this.focusRef = React.createRef();
    }
    componentDidMount() {
      const { appData } = this.context;
      const { cache } = appData;
      this.cache = cache;
      let searchCriteria = this.state.searchCriteria;
      searchCriteria.companyCode = companyCode;
      this.setState({ searchCriteria: searchCriteria });
      if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
        this.state.is3PL = true;
        this.setState({
          is3PL: true,
        });
      }
      if (this.focusRef.current) this.focusRef.current.focus();
      const attribute_cache = { ...this.cache };
      // let attribute_cache = JSON.parse(localStorage.getItem("attributeCache"));
      let incoTerms = attribute_cache.incoTerms;
      let incoTerms_temp=[];
      if (incoTerms != null || incoTerms != undefined) {
        incoTerms.map((attr) => {
          incoTerms_temp.push(attr);
            this.state.incoTerms=ModuleUtils.isActiveAttribute(incoTerms_temp);
        });
      }
      this.initLookupHandlers();
    }
    initLookupHandlers = () => {
      let incoTermsLookupHandler = new GenericAttributeLookupHandler(
        this.state.incoTerms,
        "incoTerms"
      );
      this.setState({ incoTermsLookupHandler: incoTermsLookupHandler });

      let vendorLookupHandler = new VendorLookupHandler(companyCode, "Vendor");
      this.setState({ vendorLookupHandler: vendorLookupHandler });
      let fabricLookupHandler = new FabricStyleLookupHandler(
        companyCode,
        this.state.is3PL ? "Item" : "Fabric Style"
      );
      this.setState({ fabricLookupHandler: fabricLookupHandler });
    };
    continueButtonClick = () => {
      this.props.searchCriteriaCallBack(this.state.searchCriteria);
    };
    onChange = (e) => {
      let temp_searchCriteria = this.state.searchCriteria;
      temp_searchCriteria[e.target.name] = e.target.value;
      this.setState({ searchCriteria: temp_searchCriteria });
    };
    clearCriteria = () => {
      let searchCriteria = new PurchaseOrderSearchCriteria();
      searchCriteria.companyCode = companyCode;
      this.setState({
        searchCriteria: searchCriteria,
        isShowColorLookup: false,
        colorLookupHandler: null,
      });
      if (this.focusRef.current) this.focusRef.current.focus();
    };
    onContainerKeyDown = (e) => {
      if (e.ctrlKey && e.keyCode == "191") {
        this.continueButtonClick();
      }
    };
    incotermOnChange = (e) => {
      let incoTerms = e.target.value;
      this.state.showAutoCompleteincoTermsList = true;
      let criteria = this.state.searchCriteria;
      let showAutoCompleteList = this.state.showAutoCompleteincoTermsList;
      if (isEmpty(incoTerms)) {
        this.state.showAutoCompleteincoTermsList = false;
        let showAutoCompleteList = this.state.showAutoCompleteincoTermsList;
        let criteria = this.state.searchCriteria;
        criteria.incoterm = "";
        let suggestion = [];
        this.setState({
          showAutoCompleteList: showAutoCompleteList,
          searchCriteria: criteria,
          incoTermsPageListForAutoCompleteList: suggestion,
        });
      } else if (showAutoCompleteList === true && incoTerms !== "") {
        this.readincoTermsBySearchString(incoTerms);
      }
      if (e.target.name == "incoterm") {
        criteria[e.target.name] = e.target.value;
        let incoTermsList = this.state.incoTerms;
        incoTermsList.map((pdtType) => {
          if (pdtType.code == e.target.value) {
            criteria["incoterm"] = pdtType.code;
            this.state.showAutoCompleteincoTermsList = false;
            let showAutoCompleteList = this.state.showAutoCompleteincoTermsList;
            this.setState({
              showAutoCompleteincoTermsList: showAutoCompleteList,
            });
          }
        });
      }
      this.setState({
        searchCriteria: criteria,
      });
    };
    readincoTermsBySearchString(searchString) {
      let incoTermsData = this.state.incoTerms;
      let simpleAutoCompleteList = new Array();
      if (incoTermsData.length > 0 && incoTermsData != null) {
        incoTermsData.map((incoTerms) => {
          let simpleItemBean = {
            code: incoTerms.code,
            description: incoTerms.description,
          };
          simpleAutoCompleteList.push(simpleItemBean);
        });
      }
      let userInput = searchString;
      let filteredSuggestions = new Array();
      filteredSuggestions = simpleAutoCompleteList.filter(
        (simpleAutoCompleteincoTermsLists) =>
          simpleAutoCompleteincoTermsLists.code
            .toLowerCase()
            .indexOf(userInput.toLowerCase()) > -1
      );
      this.setState({
        incoTermsPageListForAutoCompleteList: filteredSuggestions,
      });
    }
    incoTermsEnterKeyEventHandler = (e) => {
      let searchCriteria = this.state.searchCriteria;
      searchCriteria["incoterm"] = e.target.value;
      let incoTermList = this.state.incoTerms;
      let incoTermBean = null;
      incoTermList.map((inco) => {
        if (inco.code == e.target.value) {
          incoTermBean = inco;
        }
      });
      if (!isEmpty(incoTermBean)) {
        searchCriteria.incoterm = incoTermBean.code;
        this.setState({
          searchCriteria: searchCriteria,
          incoTermsPageListForAutoCompleteList: new Array(),
        });
      }
    };
    displayAutoCompleteincoTermsList = (showAutoCompleteList) => {
      this.setState({ showAutoCompleteincoTermsList: showAutoCompleteList });
    };

    vendorCodeOnChange = (e) => {
      let vendorCode = e.target.value;
      this.state.showAutoCompleteVendorList = true;
      let tempCriteria = this.state.searchCriteria;
      let showAutoCompleteList = this.state.showAutoCompleteVendorList;
      if (isEmpty(vendorCode)) {
        this.state.showAutoCompleteVendorList = false;
        let showAutoCompleteList = this.state.showAutoCompleteVendorList;
        let criteria = this.state.searchCriteria;
        criteria.vendorCode = "";
        let suggestion = [];
        this.setState({
          showAutoCompleteList: showAutoCompleteList,
          searchCriteria: criteria,
          vendorPageListForAutoCompleteList: suggestion,
        });
      } else if (
        e.target.name == "vendorCode" &&
        showAutoCompleteList === true &&
        vendorCode !== ""
      ) {
        this.readVendorBySearchString(e.target.value);
      }
      tempCriteria[e.target.name] = e.target.value;
      this.setState({ searchCriteria: tempCriteria });
    };
    readandsetVendorDetailResponse = (response) => {
      let criteria = this.state.searchCriteria;
      if (response.data != null && response.data.vendor != null) {
        let vendorData = response.data.vendor;
        if (!isEmpty(vendorData)) {
          criteria.vendorCode = vendorData.code;
          this.setState({
            searchCriteria: criteria,
          });
        }
      }
    };
    readandsetVendorDetail = (vendorCode) => {
      let input = new RestReadRequest();
      input.companyCode = companyCode;
      input.code = vendorCode;
      // input.isLoadChildren = true;
      VendorService.readVendor(
        input,
        this.readandsetVendorDetailResponse,
        this.errorCallBack
      );
    };
    readVendorBySearchString(searchString) {
      let searchCriteria = new VendorSearchCriteria();
      searchCriteria.companyCode = companyCode;
      searchCriteria.vendorCodeStartsWith = searchString;
      searchCriteria.vendorNameContains = searchString;
      let pageList = new PageListBean();
      pageList.pageSize = 100;
      let input = new RestVendorListRequest();
      input.companyCode = companyCode;
      input.pageInput = pageList;
      input.code = searchString;
      input.searchCriteria = searchCriteria;
      VendorService.getVendorPageList(
        input,
        this.readByVendorCodeResponse,
        this.errorCallBack
      );
    }
    readByVendorCodeResponse = (response) => {
      if (
        response.data != null &&
        response.data.vendorPageList != null &&
        response.data.vendorPageList.vendors != null
      ) {
        let vendorCodeData = response.data.vendorPageList.vendors;
        let simpleAutoCompleteList = new Array();
        if (vendorCodeData.length > 0 && vendorCodeData != null) {
          vendorCodeData.map((vendorCode) => {
            let simpleItemBean = {
              code: vendorCode.code,
              description: vendorCode.description,
            };
            simpleAutoCompleteList.push(simpleItemBean);
          });
        }
        this.setState({
          vendorPageListForAutoCompleteList: simpleAutoCompleteList,
        });
      }
    };
    vendorCodeEnterKeyEventHandler = (e) => {
      let vendorCode = e.target.value;
      this.readandsetVendorDetail(vendorCode);
      this.setState({
        vendorPageListForAutoCompleteList: new Array(),
      });
    };
    displayAutoCompleteVendorList = (showAutoCompleteList) => {
      this.setState({ showAutoCompleteVendorList: showAutoCompleteList });
    };

    fabricCodeOnChange = (e) => {
      let fabricStyleCode = e.target.value;
      this.state.showAutoCompleteFabricList = true;
      let tempCriteria = this.state.searchCriteria;
      let showAutoCompleteList = this.state.showAutoCompleteFabricList;
      if (isEmpty(fabricStyleCode)) {
        this.state.showAutoCompleteFabricList = false;
        let showAutoCompleteList = this.state.showAutoCompleteFabricList;
        let criteria = this.state.searchCriteria;
        criteria.fabricStyleCode = "";
        let suggestion = [];
        this.setState({
          showAutoCompleteFabricList: showAutoCompleteList,
          searchCriteria: criteria,
          fabricPageListForAutoCompleteList: suggestion,
        });
      } else if (
        e.target.name == "fabricStyleCode" &&
        showAutoCompleteList === true &&
        fabricStyleCode !== ""
      ) {
        this.readFabricBySearchString(e.target.value);
      }
      tempCriteria[e.target.name] = e.target.value;
      this.setState({ searchCriteria: tempCriteria });
    };
    readandsetFabricStyleDetailResponse = (response) => {
      let criteria = this.state.searchCriteria;
      this.setState({
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
      if (response.data != null && response.data.fabricStyle != null) {
        let fabricStyle = response.data.fabricStyle;
        if (!isEmpty(fabricStyle)) {
          criteria.fabricStyleCode = fabricStyle.code;
          this.setState({
            searchCriteria: criteria,
          });
        }
      }
    };
    readandsetFabricStyleDetail = (fabricStyleCode) => {
      let input = new RestReadRequest();
      input.companyCode = companyCode;
      input.code = fabricStyleCode;
      FabricStyleService.readFabricStyle(
        input,
        this.readandsetFabricStyleDetailResponse,
        this.errorCallBack
      );
    };

    readFabricBySearchString(searchString) {
      let searchCriteria = new FabricStyleSearchCriteria();
      searchCriteria.companyCode = companyCode;
      searchCriteria.fabricStyleCodeStartsWith = searchString;
      searchCriteria.fabricStyleNameStartsWith = searchString;
      let pageList = new RestPageListBean();
      pageList.pageSize = 100;
      let input = new RestFabricStyleListBeanRequest();
      input.companyCode = companyCode;
      input.pageInput = pageList;
      input.code = searchString;
      input.searchCriteria = searchCriteria;
      FabricStyleService.getActiveFabricStylesForAutoComplete(
        input,
        this.readByFabricCodeResponse,
        this.errorCallBack
      );
    }
    readByFabricCodeResponse = (response) => {
      let fabricStyleData = response.data.fabricStylePageList.fabricStyles;
      let simpleAutoCompleteList = new Array();
      if (fabricStyleData.length > 0 && fabricStyleData != null) {
        fabricStyleData.map((fabricStyle) => {
          let simpleItemBean = {
            code: fabricStyle.fabricStyleCode,
            description: fabricStyle.fabricStyleName,
          };
          simpleAutoCompleteList.push(simpleItemBean);
        });
      }
      this.setState({
        fabricPageListForAutoCompleteList: simpleAutoCompleteList,
      });
    };
    fabricEnterKeyEventHandler = (e) => {
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Reading ...",
      });
      this.readandsetFabricStyleDetail(e.target.value);
      this.setState({ fabricPageListForAutoCompleteList: new Array() });
    };
    displayAutoCompleteFabricList = (showAutoCompleteFabricList) => {
      this.setState({ showAutoCompleteFabricList: showAutoCompleteFabricList });
    };
    errorCallBack = (error) => {
      this.setState({
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
      ShowError(error);
    };
    render() {
      let searchCriteria = this.state.searchCriteria;
      const is3PL = this.state.is3PL;
      return (
        <div>
          <ProgressBar
            progressLoadingText={this.state.progressLoadingText}
            isShowPopup={this.state.isShowProgressBarPopup}
          />
          <Container onKeyDown={this.onContainerKeyDown}>
            <Row>
              <Col sm={5}>
                <FormLabel>Purchase Order NumberStarts With</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="purchaseOrderNumberStartsWith"
                  name="purchaseOrderNumberStartsWith"
                  onChange={this.onChange}
                  value={searchCriteria.purchaseOrderNumberStartsWith}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>Purchase Order NumberContains</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="purchaseOrderNumberContains"
                  name="purchaseOrderNumberContains"
                  onChange={this.onChange}
                  value={searchCriteria.purchaseOrderNumberContains}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>PurchaseOrderNumber</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="purchaseOrderNumber"
                  name="purchaseOrderNumber"
                  onChange={this.onChange}
                  value={searchCriteria.purchaseOrderNumber}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>Vendor</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="vendorCode"
                  name="vendorCode"
                  onChange={this.vendorCodeOnChange}
                  value={searchCriteria.vendorCode}
                  lookupRequired={true}
                  lookupHandler={this.state.vendorLookupHandler}
                  showCriteriaDialog={true}
                  enterKeyEventHandler={this.vendorCodeEnterKeyEventHandler}
                  autoCompleteListData={
                    this.state.vendorPageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={this.displayAutoCompleteVendorList}
                  showAutoCompleteList={this.state.showAutoCompleteVendorList}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                {is3PL ? (
                  <FormLabel>Item</FormLabel>
                ) : (
                  <FormLabel>FabricStyle#</FormLabel>
                )}
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="fabricStyleCode"
                  name="fabricStyleCode"
                  value={searchCriteria.fabricStyleCode}
                  onChange={this.fabricCodeOnChange}
                  lookupRequired={true}
                  lookupHandler={this.state.fabricLookupHandler}
                  showCriteriaDialog={true}
                  enterKeyEventHandler={this.fabricEnterKeyEventHandler}
                  autoCompleteListData={
                    this.state.fabricPageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={this.displayAutoCompleteFabricList}
                  showAutoCompleteList={this.state.showAutoCompleteFabricList}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>IncoTerm</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="incoterm"
                  name="incoterm"
                  onChange={this.incotermOnChange}
                  value={searchCriteria.incoterm}
                  lookupRequired={true}
                  lookupHandler={this.state.incoTermsLookupHandler}
                  enterKeyEventHandler={this.incoTermsEnterKeyEventHandler}
                  autoCompleteListData={
                    this.state.incoTermsPageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={
                    this.displayAutoCompleteincoTermsList
                  }
                  showAutoCompleteList={
                    this.state.showAutoCompleteincoTermsList
                  }
                />
              </Col>
            </Row>

            <Row>
              <Col sm={5}>
                <FormLabel>Status</FormLabel>
              </Col>
              <Col sm={7}>
                <FormControl
                  as="select"
                  custom
                  onChange={this.onChange}
                  name="orderStatus"
                  value={searchCriteria.orderStatus}
                >
                  <option value={""}></option>
                  <option value={"A"}>Approved</option>
                  <option value={"U"}>UnApproved</option>
                  <option value={"R"}>Received</option>
                  <option value={"I"}>Partially Received</option>
                  <option value={"H"}>Force Close</option>
                  <option value={"X"}>Cancelled</option>
                </FormControl>
              </Col>
            </Row>

            <Row>
              <Col sm={5}>
                <FormLabel>Created Date</FormLabel>
              </Col>
              <Col sm={3}>
                <DatePickerComponent
                  id="createdDate"
                  name="createdDate"
                  onChange={this.onChange}
                  value={searchCriteria.createdDate}
                />
              </Col>
              <Col sm={1}>
                <FormLabel>Startdate</FormLabel>
              </Col>
              <Col sm={3}>
                <DatePickerComponent
                  id="orderDate"
                  name="orderDate"
                  onChange={this.onChange}
                  value={searchCriteria.orderDate}
                />
              </Col>
            </Row>

            <Row>
              <Col sm={5}>
                <FormLabel>Order Stop Date</FormLabel>
              </Col>
              <Col sm={3}>
                <DatePickerComponent
                  id="orderStopDateFrom"
                  name="orderStopDateFrom"
                  onChange={this.onChange}
                  value={searchCriteria.orderStopDateFrom}
                />
              </Col>
              <Col sm={1}>
                <FormLabel>To</FormLabel>
              </Col>
              <Col sm={3}>
                <DatePickerComponent
                  id="orderStopDateTo"
                  name="orderStopDateTo"
                  onChange={this.onChange}
                  value={searchCriteria.orderStopDateTo}
                />
              </Col>
            </Row>

            <div className="popup_criteria_button_align-lookup">
              <Button
                ref={this.focusRef}
                className="header_buttons btn btn-primary btn-sm enterFocus"
                onClick={this.continueButtonClick}
              >
                <TickIcon />
                Continue
              </Button>
              <Button
                className="header_buttons btn btn-primary btn-sm enterFocus"
                onClick={this.clearCriteria}
              >
                <Eraser />
                Clear
              </Button>
            </div>
          </Container>
        </div>
      );
    }
  };
};
